import React from "react";
import "../styles/services.css";
import { motion } from "framer-motion";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const services = [
  {
    title: "Corte & Lavado",
    description: "Corte personalizado y lavado suave con productos naturales.",
    prices: [
      "Corte: $15.000",
      "Lavado + Corte: $18.000",
     
      "Nutrición sola: $20.000",
    ],
  },
  {
    title: "Keratina Orgánica",
    description: "Alisado saludable sin daño, brillo y suavidad prolongada.",
    prices: [
      "Corto: $35.000",
      "Medio: $40.000",
      "Largo: $45.000",
      "Extra Largo: $50.000",
    ],
  },
  {
    title: "Coloración",
    description: "Color radiante respetando la salud y energía de tu cabello.",
    prices: [
      "Raíz: $35.000",
      "Corto completo: $35.000",
      "Medio completo: $40.000",
      "Largo completo: $50.000",
    ],
  },
  {
    title: "Mechas / Balayage",
    description: "Iluminaciones suaves o marcadas, efecto natural o artístico.",
    prices: [
      "Corto: $45.000",
      "Medio: $50.000",
      "Largo: $65.000",
      "Extra Largo: $85.000",
    ],
  },
  {
    title: "Ondulaciones",
    description: "Ondas definidas, suaves y duraderas sin resecar el cabello.",
    prices: [
      "Corto: $45.000",
      "Medio: $50.000",
      "Largo: $65.000",
    ],
  },
  {
    title: "Peinados",
    description: "Peinados naturales para eventos o días especiales.",
    prices: [
      "Brushing: $20.000",
      "Ondas o Plancha: $25.000",
      "Recogido / Trenzas: $35.000",
      "Novias / 15 años / Egreso: $50.000",
    ],
  },
];

export default function Services() {
  const navigate = useNavigate();

  return (
    <div className="services-page">
      <motion.h1
     className="titulo-servicios-container">
  <h1 className="titulo-servicios-elegante">Nuestros Servicios</h1>
  <div className="linea-dorada"></div>


    
      </motion.h1>

      <div className="services-grid">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="service-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <h2>{service.title}</h2>
            <p>{service.description}</p>
            <ul>
              {service.prices.map((price, i) => (
                <li key={i}>{price}</li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="booking-section"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <button
          className="booking-button"
          onClick={() => navigate("/Turnos")}
        >
          Reservar Turno
        </button>
      </motion.div> <motion.h1
     className="titulo-servicios-container">


    
      </motion.h1>

       {/* REDES SOCIALES */}
            <section className="redes-section">
              <motion.h2
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="text-3xl font-playfair text-[#3F342F] mb-4 text-center"
              >
                Conectá con <span className="text-[#b08b76]">Shanna</span> 🌸
              </motion.h2>
      
              <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.8 }}
                className="text-center text-[#3F342F]/80 mb-10 max-w-xl mx-auto"
              >
                Seguinos en nuestras redes para descubrir nuevos estilos, consejos y el día a día de 
                <strong> Shanna Biopeluquería</strong>.
              </motion.p>
      
              <div className="flex justify-center gap-10 mb-10">
                {[
                 { icon: <FaInstagram />, href: "https://www.instagram.com/multiespacio.shanna" },
                  { icon: <FaFacebookF />, href: "https://www.facebook.com/sandranoemi.olivares.9" },
                  { icon: <FaWhatsapp />, href: "https://wa.me/5492665041280" },
               ].map((red, i) => (
                  <motion.a
                    key={i}
                    href={red.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    whileHover={{ scale: 1.15, rotate: 5 }}
                    transition={{ duration: 0.4 }}
                    className="text-[#3F342F] hover:text-[#b08b76] text-3xl bg-[#fff] rounded-full p-4 shadow-md transition-all"
                  >
                    {red.icon}
                  </motion.a>
                ))}
              </div>
            </section>
      
            {/* FOOTER */}
            <footer className="footer">
              <p>© 2025 Shanna Biopeluquería — Todos los derechos reservados.</p>
              <p>San Luis, Argentina</p>
            </footer>
    </div>
    
  );
}
